import { forwardRef } from 'react';
import { Link as RemixLink } from 'react-router';

import useEnv from '~/hooks/useEnv';

type Props = {
  children: React.ReactNode;
  className?: string;
  external?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  to: string;
};

const ReactAppLink = forwardRef<HTMLAnchorElement, Props>(function ReactAppLink(
  { to, children, ...props },
  ref
) {
  const { SITE_BASE_URL } = useEnv();

  const url = new URL(to, SITE_BASE_URL);

  return (
    <a href={url.href} ref={ref} {...props}>
      {children}
    </a>
  );
});

const Link = forwardRef<HTMLAnchorElement, Props>(function Link(
  { to, children, external, ...props },
  ref
) {
  return external ? (
    <ReactAppLink ref={ref} to={to} {...props}>
      {children}
    </ReactAppLink>
  ) : (
    <RemixLink ref={ref} to={to} {...props}>
      {children}
    </RemixLink>
  );
});

export default Link;
